// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"0abc2323","114":"415c4933","168":"02119655","189":"c064499b","210":"87fdc82c","531":"2fbf6d7e","551":"b4496567","817":"6059adb4","955":"43dbdb47"}[chunkId] + ".chunk.css";
};